import { render, staticRenderFns } from "./OutboundList.vue?vue&type=template&id=148856df&scoped=true"
import script from "./OutboundList.vue?vue&type=script&lang=js"
export * from "./OutboundList.vue?vue&type=script&lang=js"
import style0 from "./OutboundList.vue?vue&type=style&index=0&id=148856df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148856df",
  null
  
)

export default component.exports